export default "__VITE_ASSET__BHbF8taM__"